/**
 * BlogENBlogPageView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait BlogENBlogPage
 */

import { useBlogENBlogPageLogic } from '@/hooks/traits/useBlogENBlogPageLogic';
import type { BlogENBlogPageConfig } from '@/hooks/traits/useBlogENBlogPageLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { BlogENBlogView as BlogENBlogViewEntity } from '@app/shared';
import { Stack } from '@almadar/ui/components';
import { BlogENBlogHeaderView } from '@/components/traits/BlogENBlogHeaderView';
import { BlogENBlogPostsView } from '@/components/traits/BlogENBlogPostsView';
import { BlogENBlogFooterView } from '@/components/traits/BlogENBlogFooterView';
import { BlogENBlogHeroView } from '@/components/traits/BlogENBlogHeroView';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface BlogENBlogPageViewProps {
  config?: Partial<BlogENBlogPageConfig>;
}

export function BlogENBlogPageView({ config: propsConfig }: BlogENBlogPageViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useBlogENBlogPageLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['BlogENBlogView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="BlogEN" trait="BlogENBlogPage">
      <UISlotComponent slot="main" pattern={slotWriter['main'] === 'INIT' ? "stack" : "clear"} sourceTrait="BlogENBlogPage">{slotWriter['main'] === 'INIT' ? (<Stack direction="vertical" gap="none"><BlogENBlogHeaderView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><BlogENBlogHeroView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><BlogENBlogPostsView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><BlogENBlogFooterView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack>) : null}</UISlotComponent>
    </TraitScopeProvider>
  );
}

export default BlogENBlogPageView;
